<div [ngClass]="containerClasses()">
  <!-- Horizontal / Underline / Pills Display -->
  @if (effectiveDisplay().startsWith('horizontal') || effectiveDisplay() === 'underline' || effectiveDisplay() === 'pills') {
    <div [ngClass]="navClasses()">
      <div class="so-tabs__tab-list">
        @for (tab of tabs(); track trackByTab($index, tab)) {
          @if (useRouter() && tab.route) {
            <a
              [ngClass]="getTabClasses(tab, $index)"
              [routerLink]="tab.route"
              [queryParams]="queryParams()"
              [style]="tab.styleButton"
              [style.--so-pill-color]="isPillsDisplay() ? (tab.activeColor) : null"
              [title]="isTabDisabled(tab) && tooltipDisabledText() ? tooltipDisabledText() : ''"
              (click)="setActiveTab($index)">
              @if (tab.componentIcon) {
                <ng-container *ngComponentOutlet="tab.componentIcon.class; inputs: tab.componentIcon.inputs"></ng-container>
              } @else if (tab.icon) {
                <so-svg-icon-ui
                  class="so-tabs__tab-icon"
                  [name]="tab.icon"
                  [size]="tab.iconSize ?? 20"
                  [color]="tab.iconColor || ''"
                  [style.transform]="'scale(' + (tab.iconScaleX ?? 1) + ',' + (tab.iconScaleY ?? 1) + ') rotate(' + (tab.iconRotation ?? 0) + 'deg)'">
                </so-svg-icon-ui>
              }
              <span class="so-tabs__tab-title" [style]="tab.styleTextSpan">{{ tab.title }}</span>
              @if (tab.badge) {
                @if (isPillsDisplay()) {
                  <so-badge-ui
                    class="so-tabs__tab-badge"
                    size="sm"
                    [pill]="true"
                    [text]="tab.badge"
                    [colors]="getPillBadgeColors(tab, $index)">
                  </so-badge-ui>
                } @else {
                  <span class="so-tabs__tab-badge" [style.background-color]="getBadgeColor(tab, $index)">
                    {{ tab.badge }}
                  </span>
                }
              }
              @if (tab.showNotificationIcon) {
                <span class="so-tabs__notification material-icons">notifications</span>
              }
            </a>
          } @else {
            <button
              type="button"
              [matTooltip]="tab.tooltip"
              [ngClass]="getTabClasses(tab, $index)"
              [disabled]="isTabDisabled(tab)"
              [style]="tab.styleButton"
              [style.--so-pill-color]="isPillsDisplay() ? (tab.activeColor) : null"
              [title]="isTabDisabled(tab) && tooltipDisabledText() ? tooltipDisabledText() : ''"
              (click)="setActiveTab($index)">
              @if (tab.componentIcon) {
                <ng-container *ngComponentOutlet="tab.componentIcon.class; inputs: tab.componentIcon.inputs"></ng-container>
              } @else if (tab.icon) {
                <so-svg-icon-ui
                  class="so-tabs__tab-icon"
                  [name]="tab.icon"
                  [size]="tab.iconSize ?? 20"
                  [color]="tab.iconColor || ''"
                  [style.transform]="'scale(' + (tab.iconScaleX ?? 1) + ',' + (tab.iconScaleY ?? 1) + ') rotate(' + (tab.iconRotation ?? 0) + 'deg)'">
                </so-svg-icon-ui>
              }
              <span class="so-tabs__tab-title" [style]="tab.styleTextSpan">{{ tab.title }}</span>
              @if (tab.badge) {
                @if (isPillsDisplay()) {
                  <so-badge-ui
                    class="so-tabs__tab-badge"
                    size="sm"
                    [pill]="true"
                    [text]="tab.badge"
                    [colors]="getPillBadgeColors(tab, $index)">
                  </so-badge-ui>
                } @else {
                  <span class="so-tabs__tab-badge" [style.background-color]="getBadgeColor(tab, $index)">
                    {{ tab.badge }}
                  </span>
                }
              }
              @if (tab.showNotificationIcon) {
                <span class="so-tabs__notification material-icons">notifications</span>
              }
            </button>
          }
        }
      </div>
      @if (effectiveDisplay() === 'underline' && animated()) {
        <div class="so-tabs__indicator" [ngStyle]="indicatorStyle()"></div>
      }
    </div>
  }

  <!-- Vertical Display -->
  @if (effectiveDisplay() === 'vertical') {
    <div class="so-tabs__vertical-container">
      <nav [ngClass]="navClasses()">
        @for (tab of tabs(); track trackByTab($index, tab)) {
          @if (useRouter() && tab.route) {
            <a
              [ngClass]="getTabClasses(tab, $index)"
              [routerLink]="tab.route"
              [queryParams]="queryParams()"
              [title]="isTabDisabled(tab) && tooltipDisabledText() ? tooltipDisabledText() : ''"
              (click)="setActiveTab($index)">
              @if (tab.componentIcon) {
                <ng-container *ngComponentOutlet="tab.componentIcon.class; inputs: tab.componentIcon.inputs"></ng-container>
              } @else if (tab.icon) {
                <so-svg-icon-ui
                  class="so-tabs__tab-icon"
                  [name]="tab.icon"
                  [size]="tab.iconSize ?? 20"
                  [color]="tab.iconColor || ''"
                  [style.transform]="'scale(' + (tab.iconScaleX ?? 1) + ',' + (tab.iconScaleY ?? 1) + ') rotate(' + (tab.iconRotation ?? 0) + 'deg)'">
                </so-svg-icon-ui>
              }
              <span class="so-tabs__tab-title">{{ tab.title }}</span>
              @if (tab.badge) {
                <span class="so-tabs__tab-badge">{{ tab.badge }}</span>
              }
            </a>
          } @else {
            <button
              type="button"
              [matTooltip]="tab.tooltip"
              [ngClass]="getTabClasses(tab, $index)"
              [disabled]="isTabDisabled(tab)"
              [title]="isTabDisabled(tab) && tooltipDisabledText() ? tooltipDisabledText() : ''"
              (click)="setActiveTab($index)">
              @if (tab.componentIcon) {
                <ng-container *ngComponentOutlet="tab.componentIcon.class; inputs: tab.componentIcon.inputs"></ng-container>
              } @else if (tab.icon) {
                <so-svg-icon-ui
                  class="so-tabs__tab-icon"
                  [name]="tab.icon"
                  [size]="tab.iconSize ?? 20"
                  [color]="tab.iconColor || ''"
                  [style.transform]="'scale(' + (tab.iconScaleX ?? 1) + ',' + (tab.iconScaleY ?? 1) + ') rotate(' + (tab.iconRotation ?? 0) + 'deg)'">
                </so-svg-icon-ui>
              }
              <span class="so-tabs__tab-title">{{ tab.title }}</span>
              @if (tab.badge) {
                <span class="so-tabs__tab-badge">{{ tab.badge }}</span>
              }
            </button>
          }
        }
      </nav>
      @if (showContent()) {
        <div [ngClass]="contentClasses()">
          <ng-content></ng-content>
        </div>
      }
    </div>
  }

  <!-- Sections / Rail Display -->
  @if (effectiveDisplay() === 'sections' || isRailDisplay()) {
    <div class="so-tabs__sections-container" [class.so-tabs__sections-container--rail]="isRailDisplay()">
      @if (isRailDisplay()) {
        <nav class="so-tabs__rail">
          @for (tab of tabs(); track trackByTab($index, tab)) {
            <button
              type="button"
              [ngClass]="getRailItemClasses(tab, $index)"
              [disabled]="isTabDisabled(tab)"
              [title]="tab.title"
              [attr.aria-current]="isActive($index) ? 'page' : null"
              (click)="setActiveTab($index)">
              @if (tab.componentIcon) {
                <ng-container *ngComponentOutlet="tab.componentIcon.class; inputs: tab.componentIcon.inputs"></ng-container>
              } @else if (tab.icon || tab.svgIcon) {
                <so-svg-icon-ui
                  class="so-tabs__rail-icon"
                  [name]="tab.icon || ''"
                  [src]="tab.svgIcon || ''"
                  [size]="tab.iconSize ?? 28"
                  [color]="tab.borderColor || sectionBorderColor()" />
              }
              <span class="so-tabs__rail-label">{{ getRailLabel(tab) }}</span>
            </button>
          }
        </nav>
      } @else {
        <nav class="so-tabs__sections-nav">
          @for (tab of tabs(); track trackByTab($index, tab)) {
            <so-section-card-ui
              [title]="tab.title"
              [icon]="tab.icon || ''"
              [svgIcon]="tab.svgIcon || ''"
              [borderColor]="tab.borderColor || sectionBorderColor()"
              [active]="isActive($index)"
              [disabled]="isTabDisabled(tab)"
              (cardClick)="setActiveTab($index)" />
          }
        </nav>
      }
      <div class="so-tabs__sections-content" [class.so-tabs__sections-content--card]="contentCard()">
        @if (showPlaceholder()) {
          <div class="so-tabs__placeholder">
            <div class="so-tabs__placeholder-icon">
              <span class="material-icons">{{ placeholderIcon() }}</span>
            </div>
            <span class="so-tabs__placeholder-text">{{ placeholderText() }}</span>
          </div>
        } @else if (showContent()) {
          <ng-content select="[sections-content]"></ng-content>
        }
      </div>
    </div>
  }

  <!-- Steps Display -->
  @if (effectiveDisplay() === 'steps') {
    <div class="so-tabs__steps-container">
      <div class="so-tabs__stepper">
        @for (tab of tabs(); track trackByTab($index, tab); let last = $last) {
          <div [ngClass]="getStepClasses(tab, $index)">
            <button
              type="button"
              class="so-tabs__step-button"
              [matTooltip]="tab.tooltip"
              [disabled]="!allowStepNavigation() || isTabDisabled(tab)"
              [title]="tab.title"
              (click)="setActiveTab($index)">
              @if (showStepNumbers()) {
                <span class="so-tabs__step-number">{{ $index + 1 }}</span>
              } @else if (tab.componentIcon) {
                <ng-container *ngComponentOutlet="tab.componentIcon.class; inputs: tab.componentIcon.inputs"></ng-container>
              } @else if (tab.icon) {
                <so-svg-icon-ui
                  class="so-tabs__step-icon"
                  [name]="tab.icon"
                  [size]="tab.iconSize ?? 20"
                  [color]="tab.iconColor || ''"
                  [style.transform]="'scale(' + (tab.iconScaleX ?? 1) + ',' + (tab.iconScaleY ?? 1) + ') rotate(' + (tab.iconRotation ?? 0) + 'deg)'">
                </so-svg-icon-ui>
              }
              <span class="so-tabs__step-title">{{ tab.title }}</span>
            </button>
            @if (!last) {
              <div class="so-tabs__step-line"></div>
            }
          </div>
        }
      </div>
      @if (showContent()) {
        <div [ngClass]="contentClasses()">
          <ng-content select="[steps-content]"></ng-content>
        </div>
      }
    </div>
  }

  <!-- Default content for horizontal/underline/pills -->
  @if (showContent() && (effectiveDisplay() === 'horizontal' || effectiveDisplay() === 'underline' || effectiveDisplay() === 'pills')) {
    <div [ngClass]="contentClasses()">
      <ng-content></ng-content>
    </div>
  }
</div>
